import { useEffect, useState } from "react"
import "./style.less"

const CountDown = (props) => {
  const { time, onTimeOver } = props
  const [remain, setRemain] = useState(time)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    if (time === 0) {
      return
    }

    // 倒计时结束，调用
    if (remain <= 0) {
      onTimeOver()
      return
    }

    // 设置组件显示时间
    setMinutes(Math.floor(remain / 60))
    setSeconds(remain % 60)

    // 倒计时1秒
    setTimeout(() => {
      setRemain(remain - 1)
    }, 1000);

  }, [remain])


  if (time === 0 || remain <= 0) {
    return <></>
  }

  return (
    time === 0 ? <></> :
      <div className="count-down-wrapper">
        <div>订单将在 <span>{minutes}</span> 分 <span>{seconds}</span> 秒后自动取消，</div>
        <div>请尽快支付！</div>
      </div>
  )
}

export default CountDown